import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/ant-design-vue.js'
import './plugins/app-components'
import VueStorage from 'vue-ls'
import Directives from './directive'
import bootstrap from './utils/bootstrap'
import './components/global.less'
import './mixins/GLOBALDATA'
import * as tools from './utils/tools'
import './http'

Vue.use(Directives)
Vue.config.productionTip = false
Vue.prototype.$u = tools

Vue.use(VueStorage, {
  namespace: 'pms__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
})

new Vue({
  router,
  store,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
